import { useEffect, useState } from "react";

export const useMcqQuestions = (
  generatedQuestionsFromSubmitContent,
  setTotalQuestionNumber,
  totalQuestionNumber
) => {
  const [mcqsQuestions, setMCQsQuestions] = useState([]);

  const [editingOptionIndices, setEditingOptionIndices] = useState({});

  const handleOptionEdit = (questionIndex, optionIndex) => {
    setEditingOptionIndices({
      ...editingOptionIndices,
      [questionIndex]: optionIndex,
    });
  };

  const handleOptionChange = (questionIndex, optionIndex, newValue) => {
    const updatedQuestions = [...mcqsQuestions];
    const question = updatedQuestions[questionIndex];
  
    const options = question.Options; // Use capital O as per your data
  
    if (!options || !Array.isArray(options) || !options[optionIndex]) {
      console.error("Options array or the specific option is invalid", { options, optionIndex });
      return;
    }
      
    const currentAnswer = question.answer ?? question.Answer;
  
    // Update the answer if the modified option is the current answer
    if (currentAnswer === options[optionIndex]) {
      if ('answer' in question) {
        question.answer = newValue;
      } else if ('Answer' in question) {
        question.Answer = newValue;
      }
    }
  
    // Update the option text
    options[optionIndex] = newValue;
  
    // Persist the updated state
    setMCQsQuestions(updatedQuestions);
  };
  

  const handleOptionBlur = (questionIndex) => {
    const updatedIndices = { ...editingOptionIndices };
    delete updatedIndices[questionIndex];
    setEditingOptionIndices(updatedIndices);
  };

  const handleMcqQuestionsEdit = (index) => {
    const updatedQuestions = [...mcqsQuestions];
    updatedQuestions[index].editing = !updatedQuestions[index].editing;

    if (updatedQuestions[index].editing) {
      // After setting editing to true, focus on the contentEditable div for the question
      setTimeout(() => {
        const contentEditableElement = document.getElementById(
          `question-${index}`
        ); // Add an ID to your contentEditable element
        if (contentEditableElement) {
          contentEditableElement.focus();
        }
      }, 0);
    }

    setMCQsQuestions(updatedQuestions);
  };

  const handleMcqQuestionDelete = (index) => {
    let updatedQuestions = [...mcqsQuestions];
    updatedQuestions.splice(index, 1); // Remove the question at the given index
    updatedQuestions = updatedQuestions.map((u, i) => ({ ...u, index: i }));
    setTotalQuestionNumber(totalQuestionNumber - 1);
    setMCQsQuestions(updatedQuestions);
  };

  const handleMcqQuestionChange = (index, newValue) => {
    const updatedQuestions = [...mcqsQuestions];
    
     // Fallback logic for key casing
    if ("question" in updatedQuestions[index]) {
        updatedQuestions[index].question = newValue;
    } else if ("Question" in updatedQuestions[index]) {
        updatedQuestions[index].Question = newValue;
    }
    setMCQsQuestions(updatedQuestions);
  };

  const handleMCQAnswersEdit = (index) => {
    const updatedQuestions = [...mcqsQuestions];
    if (updatedQuestions[index]) {
      updatedQuestions[index].editingAnswer =
        !updatedQuestions[index].editingAnswer;
      setMCQsQuestions(updatedQuestions);
    }
  };

  const handleMCQAnswerChange = (index, newValue) => {
    const updatedQuestions = [...mcqsQuestions];

    if("answer" in updatedQuestions[index]){
      updatedQuestions[index].answer = newValue.trim();
    }else if("Answer" in updatedQuestions[index]) {
    updatedQuestions[index].Answer = newValue.trim();
    }
    setMCQsQuestions(updatedQuestions);
  };

  useEffect(() => {
    if (generatedQuestionsFromSubmitContent) {
      let mcq = generatedQuestionsFromSubmitContent?.response?.questions?.questionset?.mcqs_questions
      ?.questions ||
      generatedQuestionsFromSubmitContent?.response?.questions?.questionset?.mcqs_questions ||
      generatedQuestionsFromSubmitContent?.questionset?.mcqs_questions
        ?.questions ||
      generatedQuestionsFromSubmitContent?.questionset?.mcqs_questions ||
      [];
    mcq = mcq.map((m, index) => ({ ...m, category: 'mcq', index }));
    setMCQsQuestions(mcq);
    }
  }, [generatedQuestionsFromSubmitContent]);

  return {
    mcqsQuestions,
    handleMcqQuestionsEdit,
    handleMcqQuestionDelete,
    handleMcqQuestionChange,
    handleOptionEdit,
    handleOptionChange,
    handleOptionBlur,
    editingOptionIndices,
    handleMCQAnswersEdit,
    handleMCQAnswerChange,
  };
};
